import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getJobs as getFirebaseJobs } from '../lib/firebase/jobs';
import { getSupabaseJobs } from '../lib/supabase/jobs';
import type { Job } from '../types/jobs';

export function useJobs() {
  const { user, firebaseUser } = useAuth();
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const loadJobs = async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Load jobs from both Firebase (existing) and Supabase (new)
      const [firebaseResult, supabaseResult] = await Promise.all([
        getFirebaseJobs(),
        getSupabaseJobs()
      ]);
      
      if (firebaseResult.error) {
        console.warn('Error loading Firebase jobs:', firebaseResult.error);
      }
      
      if (supabaseResult.error) {
        console.warn('Error loading Supabase jobs:', supabaseResult.error);
      }
      
      // Combine jobs from both sources
      const allJobs = [
        ...supabaseResult.jobs, // Put Supabase jobs first (newer)
        ...firebaseResult.jobs
      ];
      
      setJobs(allJobs);
    } catch (err) {
      console.error('Error loading jobs:', err);
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadJobs();
  }, []);

  return { 
    jobs, 
    loading, 
    error,
    refreshJobs: loadJobs,
    setJobs
  };
}